import { t } from "@lingui/macro";
import { EApiDatafanProgressType, IApiDatafanProgress } from "@smp/api";

export const aggregateDatafanProgressValue = (
  progress: IApiDatafanProgress,
) => {
  const item = progress.items[progress.current_item_sign];

  if (item.type === EApiDatafanProgressType.PERCENT) {
    return `${
      item.total ? Math.round((100 / item.total) * item.current) : 100
    }%`;
  } else if (item.type === EApiDatafanProgressType.COUNT) {
    return `${item.current}\xa0${t`of`}\xa0${item.total}`;
  } else if (item.type === EApiDatafanProgressType.TIMER) {
    return item.total - item.current;
  } else if (item.type === EApiDatafanProgressType.SIMPLE_COUNT) {
    return `${item.current}`;
  } else {
    return "";
  }
};
